import { ABaseModel } from '../abstracts/ABaseModel.js';
import {
  ISeller,
  ISellerListResult,
  ISellerPaginationResult,
  ISellerShippingTable,
  ISellerShippingTableListResult,
  ISellerShippingTableRate,
  ISellerShippingTableRateListResult,
  ISellerPaymentMethodType,
  ISellerPaymentMethodTypeListResult,
  ISellerPaymentMethodAttribute,
  ISellerPaymentMethod,
  ISellerPaymentMethodListResult,
} from '../interfaces/Seller.js';
import { PaginationResult, ListResult } from './List.js';

/**
 * Seller
 */
class Seller extends ABaseModel implements ISeller {
  id: number;
  type: number;
  status: number;
  name: string;
  integrationId: number;
  onboardingStage: number;
  entityId: number;
  entityName: string;
  entityStatus: number;
  entityRole: string;
  entitySlug: string;
  shipsCountryCode: string;
  storeCode: string;
  language: string;
  locale: string;
  taxStatus: number;
  street1: string;
  street2: string;
  city: string;
  countryCode: string;
  region: string;
  postcode: string;
  vatCode: string;
  vatCountryCode: string;
  companyName: string;
  companyNumber: string;
  contactName: string;
  contactPhone: string;
  contactEmail: string;
  billingName: string;
  billingPhone: string;
  billingEmail: string;
  shippingService: string;
  shipsIn: number;
  offers: boolean;
  offerAutomaticAccept: number;
  offerMaximumDiscount: number;
  away: boolean;
  awayFrom: string;
  awayTo: string;
  isCurrentlyAway: boolean;
  canInvite: boolean;
  canRentArt: boolean;
  canUseShippingTables: boolean;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * SellerListResult
 */
class SellerListResult extends ListResult implements ISellerListResult {
  declare items: Array<Seller>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * SellerPaginationResult
 */
class SellerPaginationResult extends PaginationResult implements ISellerPaginationResult {
  declare items: Array<Seller>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * SellerShippingTable
 */
class SellerShippingTable extends ABaseModel implements ISellerShippingTable {
  id: number;
  sellerId: number;
  name: string;
  default: boolean;
  currency: string;
  storeCode: string;
  parentId: number;
  parentSellerId: number;
  parentName: string;
  parentDefault: boolean;
  parentCurrency: string;
  parentStoreCode: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * SellerShippingTableListResult
 */
class SellerShippingTableListResult extends ListResult implements ISellerShippingTableListResult {
  declare items: Array<SellerShippingTable>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * SellerShippingTableRate
 */
class SellerShippingTableRate extends ABaseModel implements ISellerShippingTableRate {
  id: number;
  tableId: number;
  baseCost: number;
  pctCost: number;
  inherited: boolean;
  countryCode: string;
  regionCode: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * SellerShippingTableRateListResult
 */
class SellerShippingTableRateListResult extends ListResult implements ISellerShippingTableRateListResult {
  declare items: Array<SellerShippingTableRate>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * SellerPaymentMethodType
 */
class SellerPaymentMethodType extends ABaseModel implements ISellerPaymentMethodType {
  id: number;
  code: string;
  name: string;
  attributes: Array<string>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * SellerPaymentMethodTypeListResult
 */
class SellerPaymentMethodTypeListResult extends ListResult implements ISellerPaymentMethodTypeListResult {
  declare items: Array<SellerPaymentMethodType>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

/**
 * SellerPaymentMethodAttribute
 */
class SellerPaymentMethodAttribute extends ABaseModel implements ISellerPaymentMethodAttribute {
  name: string;
  value: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * SellerPaymentMethod
 */
class SellerPaymentMethod extends ABaseModel implements ISellerPaymentMethod {
  id: number;
  sellerId: number;
  typeCode: string;
  default: boolean;
  attributes: Array<SellerPaymentMethodAttribute>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * SellerPaymentMethodListResult
 */
class SellerPaymentMethodListResult extends ListResult implements ISellerPaymentMethodListResult {
  declare items: Array<SellerPaymentMethod>;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

export {
  Seller,
  SellerPaginationResult,
  SellerListResult,
  SellerShippingTable,
  SellerShippingTableListResult,
  SellerShippingTableRate,
  SellerShippingTableRateListResult,
  SellerPaymentMethodType,
  SellerPaymentMethodTypeListResult,
  SellerPaymentMethodAttribute,
  SellerPaymentMethod,
  SellerPaymentMethodListResult,
};
